export const bookingGuideText = {
  JP: {
    divider: 'or',

    instagram: {
      title: 'Instagram DMで予約',
      cta: 'Instagramを開く',
      note: '24時間いつでもDM受付中！',
      steps: [
        {
          number: '01',
          title: 'DMを送信',
          text: 'ご希望の日程・人数・プランなどをDMでお送りください。',
        },
        {
          number: '02',
          title: '日程の調整',
          text: '空き状況を確認し、ツアー内容や集合場所などをご案内します。',
        },
        {
          number: '03',
          title: 'ご予約確定',
          text: '内容にご納得いただけましたら、ご予約確定となります。',
        },
        {
          number: '04',
          title: 'お支払い',
          text: 'ツアー当日にお支払いをお願いいたします。',
        },
      ],
    },

    line: {
      title: '公式LINEで予約',
      cta: 'LINEを開く',
      note: 'ご相談やご質問もOK！',
      steps: [
        {
          number: '01',
          title: '友だち追加',
          text: 'LINEの友だち追加をしていただき、トークを開始します。',
        },
        {
          number: '02',
          title: '詳細のご案内',
          text: 'ご希望をお伺いし、ツアー内容や集合場所などをご案内します。',
        },
        {
          number: '03',
          title: 'ご予約確定',
          text: '内容にご納得いただけましたら、ご予約確定となります。',
        },
        {
          number: '04',
          title: 'お支払い',
          text: 'ツアー当日にお支払いをお願いいたします。',
        },
      ],
    },
  },

  EN: {
    divider: 'or',

    instagram: {
      title: 'Book via Instagram DM',
      cta: 'Open Instagram',
      note: 'DM us anytime, 24 hours a day!',
      steps: [
        {
          number: '01',
          title: 'Send us a DM',
          text: 'Please send us your preferred date, number of guests, and tour plan.',
        },
        {
          number: '02',
          title: 'Schedule adjustment',
          text: 'We will check availability and guide you through the tour details and meeting point.',
        },
        {
          number: '03',
          title: 'Confirm your booking',
          text: 'Once everything looks good, your booking will be confirmed.',
        },
        {
          number: '04',
          title: 'Payment',
          text: 'Please make your payment on the day of the tour.',
        },
      ],
    },

    line: {
      title: 'Book via Official LINE',
      cta: 'Open LINE',
      note: 'Questions and consultations are welcome!',
      steps: [
        {
          number: '01',
          title: 'Add us on LINE',
          text: 'Add our official LINE account and start a chat with us.',
        },
        {
          number: '02',
          title: 'Tour details',
          text: 'We will ask about your preferences and guide you through the tour details and meeting point.',
        },
        {
          number: '03',
          title: 'Confirm your booking',
          text: 'Once everything looks good, your booking will be confirmed.',
        },
        {
          number: '04',
          title: 'Payment',
          text: 'Please make your payment on the day of the tour.',
        },
      ],
    },
  },

  中文: {
    divider: 'or',

    instagram: {
      title: '通过 Instagram DM 预约',
      cta: '打开 Instagram',
      note: '24小时都可以发送DM咨询！',
      steps: [
        {
          number: '01',
          title: '发送DM',
          text: '请通过DM发送您希望的日期、人数和行程计划。',
        },
        {
          number: '02',
          title: '调整日期',
          text: '我们会确认空位，并为您介绍行程内容和集合地点。',
        },
        {
          number: '03',
          title: '确认预约',
          text: '确认内容无误后，即可完成预约。',
        },
        {
          number: '04',
          title: '付款',
          text: '请在行程当天付款。',
        },
      ],
    },

    line: {
      title: '通过官方 LINE 预约',
      cta: '打开 LINE',
      note: '咨询和提问也欢迎！',
      steps: [
        {
          number: '01',
          title: '添加好友',
          text: '请添加官方LINE好友，并开始聊天。',
        },
        {
          number: '02',
          title: '介绍详情',
          text: '我们会了解您的需求，并介绍行程内容和集合地点。',
        },
        {
          number: '03',
          title: '确认预约',
          text: '确认内容无误后，即可完成预约。',
        },
        {
          number: '04',
          title: '付款',
          text: '请在行程当天付款。',
        },
      ],
    },
  },

  한국어: {
    divider: 'or',

    instagram: {
      title: 'Instagram DM으로 예약',
      cta: 'Instagram 열기',
      note: '24시간 언제든지 DM 가능!',
      steps: [
        {
          number: '01',
          title: 'DM 보내기',
          text: '원하시는 날짜, 인원, 플랜 등을 DM으로 보내주세요.',
        },
        {
          number: '02',
          title: '일정 조정',
          text: '예약 가능 여부를 확인하고 투어 내용과 집합 장소를 안내해드립니다.',
        },
        {
          number: '03',
          title: '예약 확정',
          text: '내용을 확인하신 후 문제가 없으면 예약이 확정됩니다.',
        },
        {
          number: '04',
          title: '결제',
          text: '투어 당일 결제를 부탁드립니다.',
        },
      ],
    },

    line: {
      title: '공식 LINE으로 예약',
      cta: 'LINE 열기',
      note: '상담이나 질문도 가능합니다!',
      steps: [
        {
          number: '01',
          title: '친구 추가',
          text: '공식 LINE을 친구 추가하고 채팅을 시작해주세요.',
        },
        {
          number: '02',
          title: '상세 안내',
          text: '원하시는 내용을 확인한 뒤 투어 내용과 집합 장소를 안내해드립니다.',
        },
        {
          number: '03',
          title: '예약 확정',
          text: '내용을 확인하신 후 문제가 없으면 예약이 확정됩니다.',
        },
        {
          number: '04',
          title: '결제',
          text: '투어 당일 결제를 부탁드립니다.',
        },
      ],
    },
  },
};
